import React from 'react';
import PropTypes from "prop-types";

export default function CsfMembrePageHeading({title, memberName, certificatNumber}) {
  return (
    <div className="membre__page-heading w-100">
      <div className="page-heading__top d-md-flex align-items-end justify-content-between">
        <h1 className="h2">{ title }</h1>
        <p className="page-heading__info m-0 d-none d-lg-flex justify-content-end">
          {window.Drupal.t('membre.heading.cert')} { certificatNumber }
        </p>
      </div>
      <div className="d-flex justify-content-end align-items-end flex-wrap">
        <p className="page-heading__info my-0 d-block d-lg-none">
          {window.Drupal.t('membre.heading.cert')} { certificatNumber }
        </p>
        <p className="page-heading__name my-0 ml-1">{ memberName }</p>
      </div>
    </div>
  )
}

CsfMembrePageHeading.propTypes = {
  title: PropTypes.string,
  memberName: PropTypes.string,
  certificatNumber: PropTypes.string
};
